import { useDebugValue, useEffect } from 'react';
import { Dims, MeasuredCookieType, CookieDimType } from './redux/types';
import { useMeasureElementCookieState } from './useMeasureElementCookieState';
import { UseMeasuredOptions, useMeasureElement } from './useMeasureElement';

export type MeasureOptions = {
  defaultSize?: {
    desktop: Dims;
    mobile: Dims;
  };
  cookieDim?: CookieDimType;
  version?: number;
  measureOptions?: UseMeasuredOptions;
};

export function useMeasureElementCookie(
  cookieType: MeasuredCookieType | undefined,
  {
    defaultSize: defaultSizeProp,
    cookieDim = 'both',
    version = 0, // TODO is this needed
    measureOptions,
  }: MeasureOptions
) {
  const { containerSize, defaultSizeForPlatform, updateContainerSize } =
    useMeasureElementCookieState(cookieType, cookieDim, defaultSizeProp, {
      throttle: 0,
      throttleOptions: {},
    });

  useDebugValue(containerSize, size => `Width: ${size?.width}, height: ${size?.height}`);

  const { ref, dimensions } = useMeasureElement(
    measureOptions ?? {
      throttle: 250,
      throttleOptions: { trailing: true },
    }
  );

  useEffect(() => {
    updateContainerSize(dimensions as any);
  }, [dimensions, updateContainerSize]);

  return { ref, dimensions: containerSize ?? defaultSizeForPlatform };
}
